import type { OrganizationType } from "@bookdental/schemas";
import { tourDaClinica } from "./global/clinica";
import { tourDoLaboratorio } from "./global/laboratorio";
import { tourDaHibrida } from "./global/hibrida";
import { tourPessoal } from "./global/pessoal";

/** Variantes de micro-animação (ver TourDemoAnimation.tsx) pro passo final de um tour de página —
 *  ilustra o fluxo "clicar no botão principal → preencher → salvar" sem abrir o diálogo de verdade. */
export type TourDemoVariant =
  | "fill-form"
  | "schedule"
  | "send-flow"
  | "decision"
  | "invite-link"
  | "list-add";

type Posicao = "top" | "top-start" | "top-end" | "bottom" | "bottom-start" | "bottom-end" | "left" | "right" | "right-start" | "center" | "auto";

export type TourStep = {
  // Id livre: os tours de página (page-tour-steps/*) declaram os seus sem estender nada aqui.
  id: string;
  route: string;
  /** Seletor do alvo; "body" + placement "center" = passo sem alvo (boas-vindas, instrução). */
  target: string;
  title: string;
  content: string;
  /** v3 do react-joyride renomeou de "disableBeacon" — pula o beacon (bolinha pulsante que exige
   *  um clique a mais antes do tooltip abrir) em todo passo, não só no primeiro. */
  skipBeacon: true;
  demo?: TourDemoVariant;
  placement?: Posicao;
  /** Alvo fixo na tela (menu lateral, barra de abas, botão Ajuda) — o Joyride não calcula rolagem. */
  isFixed?: boolean;
};

/**
 * "Conheça a plataforma": um roteiro por tipo de organização, na ordem do trabalho de verdade —
 * pessoal, híbrida (clínica com laboratório próprio), laboratório ou clínica. No celular os passos
 * apontam pras abas de baixo; o que não tem aba vira instrução ("Menu › …"). Tudo em /inicio: o
 * tour não navega (o detalhe de cada área fica no "Ajuda" e no tour de cada página).
 */
export function getTourSteps(types: OrganizationType[], isPersonal: boolean, celular = false): TourStep[] {
  const clinica = types.includes("DENTAL_OFFICE");
  const laboratorio = types.includes("DENTAL_LAB");
  if (isPersonal) return tourPessoal(celular, clinica);
  if (clinica && laboratorio) return tourDaHibrida(celular);
  if (laboratorio) return tourDoLaboratorio(celular);
  return tourDaClinica(celular);
}
